import React from "react";
import styled from "styled-components";

import { ReactComponent as MessageIcon } from "./assets/messageIcon.svg";

const Container = styled.div`
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.p`
  margin: 0px;
  color: ${(props) => props.textColor};
  font-size: ${(props) => `${props.fontSize}px`};
  margin-left: 3px;
  font-weight: ${(props) => (props.isBold ? "bold" : "normal")};
`;

const Icon = styled(MessageIcon)`
  height: 23px;
  width: 23px;
  margin-right: 3px;
  & #message-icon-svg {
    fill: ${(props) => props.fillcolor || "#fff"};
  }
`;

const CtaInitialMessage = ({
  text,
  textColor = "#FFFFFF",
  onClick,
  fontSize,
  isInitialTextMessageBold,
}) => {
  return (
    <Container id="initial-message-cta-matador" onClick={onClick}>
      <Icon fillcolor={textColor} alt={text} />
      <Text
        fontSize={fontSize}
        textColor={textColor}
        isBold={isInitialTextMessageBold}
      >
        {text}
      </Text>
    </Container>
  );
};

export default CtaInitialMessage;
